import { render, staticRenderFns } from "./ModalWrapperOptions.vue?vue&type=template&id=aa4b6f06&"
import script from "./ModalWrapperOptions.vue?vue&type=script&lang=js&"
export * from "./ModalWrapperOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports